"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHoverStyle = exports.HoverContext = void 0;
var react_1 = require("react");
exports.HoverContext = react_1.createContext({
    isHovered: false,
    useHoverContext: false,
});
var useHoverStyle = function (hoverStyle, useNativeProps, currentStyle, componentRef) {
    var _a = react_1.useState(currentStyle), combineStyle = _a[0], setCombineStyle = _a[1];
    var _b = react_1.useState(false), isHovered = _b[0], setIsHovered = _b[1];
    var context = react_1.useContext(exports.HoverContext);
    react_1.useEffect(function () {
        setCombineStyle(currentStyle);
    }, [currentStyle]);
    if (!hoverStyle || Object.keys(hoverStyle).length === 0)
        return [{}, currentStyle, false];
    var setStyles = function (additionStyle) {
        var root = componentRef === null || componentRef === void 0 ? void 0 : componentRef.current;
        if (useNativeProps && !!root) {
            root.setNativeProps({
                style: [currentStyle, additionStyle],
            });
        }
        else {
            setCombineStyle([currentStyle, additionStyle]);
            setIsHovered(!additionStyle ? false : true);
        }
    };
    var hoverProps = context.useHoverContext ? {} : {
        onMouseEnter: function () {
            setStyles(hoverStyle);
        },
        onMouseLeave: function () {
            setStyles(null);
        }
    };
    react_1.useEffect(function () {
        if (context.isHovered) {
            setStyles(hoverStyle);
        }
        else {
            setStyles(null);
        }
    }, [context.isHovered]);
    return [hoverProps, combineStyle, isHovered];
};
exports.useHoverStyle = useHoverStyle;
//# sourceMappingURL=useHoverStyle.js.map